import React, { useEffect, useState } from "react";
import WaitlistDialog from "@/components/WaitlistDialog";
import { api } from "@/lib/api";
import { Check } from "@phosphor-icons/react";

const PERKS = [
  "Priority access at launch",
  "Locked-in launch pricing — 50% off year one",
  "Higher tool limits — 50 runs/day instead of 5",
  "Direct line to founders for feature requests",
];

export default function Waitlist() {
  const [count, setCount] = useState(null);
  useEffect(() => { api.get("/waitlist/count").then((r) => setCount(r.data.display)); }, []);
  return (
    <div className="bg-paper">
      <div className="max-w-5xl mx-auto px-6 md:px-12 py-28 md:py-36">
        <div className="label-mono text-center">№ 01 · The waitlist</div>
        <h1 className="mt-6 font-display font-black text-6xl md:text-8xl tracking-tightest text-ink leading-[0.9] text-center">
          Get on the list.<br />
          Be first when we <span className="bg-persimmon text-white px-3 -rotate-1 inline-block">launch paid.</span>
        </h1>
        <p className="mt-8 text-ink/65 max-w-2xl mx-auto text-center text-lg leading-relaxed">
          The free tools stay free. The launch waitlist gets locked-in pricing, higher limits,
          and 50% off year one.
        </p>
        <div className="mt-12 flex justify-center">
          <WaitlistDialog />
        </div>

        {count != null && (
          <div className="mt-20 bg-ink text-white p-10 md:p-12 text-center" data-testid="waitlist-social-proof">
            <div className="label-mono text-white/60">Sellers waiting</div>
            <div className="mt-3 font-mono font-medium text-7xl md:text-8xl tracking-tightest text-persimmon tabular leading-none">
              {count.toLocaleString()}
            </div>
            <div className="mt-4 label-mono text-white/40">… and counting</div>
          </div>
        )}

        <div className="mt-12 grid sm:grid-cols-2 gap-px bg-rule border border-rule">
          {PERKS.map((p, i) => {
            const colors = ["bg-persimmon text-white", "bg-cobalt text-white", "bg-butter text-ink", "bg-ink text-white"];
            return (
              <div key={p} className="bg-white p-6 md:p-8 flex gap-4 items-start">
                <span className={`w-10 h-10 grid place-items-center font-mono tabular font-bold shrink-0 ${colors[i % colors.length]}`}>
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="flex-1">
                  <div className="text-ink font-medium leading-snug">{p}</div>
                </div>
                <Check weight="bold" className="w-5 h-5 ml-auto text-ink shrink-0 mt-2" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
